import { useMemo, useCallback } from 'react';
import { renderToString } from 'react-dom/server';
import classnames from 'classnames';

import { useDivIcon } from '@entegral/helpers.leaflet/hooks/div-icon';

import { Marker } from 'react-leaflet';
import { HouseIcon } from '../icons/house';

import { shortPrice } from '../../helpers/short-price';



export function PropertyMarker({
  coords,
  bounds,
  isDetailed,
  items,


  fitBounds,
  highlight,
}) {

  let onClick = useCallback(() => {
    if (isDetailed) highlight(items);
    else fitBounds(bounds);
  }, [isDetailed]);

  let iconHtml = useMemo(() => renderToString(<PropertyMarkerIcon items={items} />), [items]);

  let iconClassName = useMemo(() => classnames(
    `map-search__marker`,
    items.length > 1 ? `map-search__marker_type_multiple` : `map-search__marker_type_single`,
  ), [items.length]);


  let iconOptions = useMemo(() => ({ className: iconClassName, html: iconHtml }), [iconClassName, iconHtml]);
  let icon = useDivIcon(iconOptions);

  return (
    <Marker
      position={coords}
      icon={icon}
      eventHandlers={{
        click: onClick,
      }}
    />
  );
}

function PropertyMarkerIcon({
  items,
}) {
  if (items.length !== 1) return (
    <>
      <div className={`map-search__caption-icon`}><HouseIcon /></div>
      <div className={`map-search__caption-count`}>{items.length > 9 ? '9+' : items.length}</div>
    </>
  );

  let property = items[0];

  if (!property.price) return `POA`;

  if (property.state === 'Sold') return `SOLD`;

  return (
    <>
      {shortPrice(property.price, property.currency)}{property.priceUnit === 'sqm' ? '/m²' : ''}
    </>
  );
}
